<template>
  <div class="product-reviews">
    <div class="product-reviews__w">
      <ReviewsPageHeader :product="product" />
      <template v-if="reviews.length > 0">
        <AttachmentGallery :reviews="galleryReviews" :product="product" />
        <Reviews :reviews="reviews" :product="product" />
        <Pagination
          :pages="pageCount"
          :current-page="params.page"
          @on-page-change="onPageChange"
          @on-load-more="onLoadMore"
        />
      </template>
    </div>
    <AsideCard :product="product" :navigation-height="navigationHeight" />
  </div>
</template>

<script setup>
import { Product } from "~/models/product.model";
import AsideCard from "~/modules/product/ui/components/AsideCard.vue";
import ReviewsPageHeader from "~/modules/product/ui/components/ReviewsPageHeader.vue";
import Reviews from "~/modules/product/ui/components/Reviews.vue";
import AttachmentGallery from "~/modules/shared/reviews/AttachmentGallery.vue";
import Pagination from "~/modules/shared/pagination/Pagination.vue";
import { useProductReviewStore } from "~/store/productReview.store.js";

const props = defineProps({
  product: { type: Product, required: true },
  navigationHeight: { type: Number, required: false },
});

const patternSeo = {
  metaTitle: {
    postfix: () => _T("@customer reviews"),
  },
  metaDescription: {
    prefix: () => _T("@Read product reviews"),
    postfix: () => _T("@online store") + " | " + _T("@Trademark"),
  },
};

configureProductSeo(props.product, patternSeo);

const productReviewStore = useProductReviewStore();
const { reviews, galleryReviews, params, pageCount } =
  storeToRefs(productReviewStore);

watch(
  [() => props.product, () => useRoute().query],
  () => {
    productReviewStore.fetch(props.product);
  },
  {
    immediate: true,
    deep: true,
  },
);

const onPageChange = (page) => {
  params.value.page = page;
};

const onLoadMore = (page) => {
  productReviewStore.loadMore(props.product, page);
};

if (0 === reviews.value.length) {
  useSeoMeta({
    robots: "noindex, nofollow",
  });
}
</script>

<style scoped lang="scss">
.product-reviews {
  @include flex-container(row, center, flex-start);
  gap: 44px;

  @include bigMobile {
    gap: 16px;
  }

  &__w {
    width: 100%;
    max-width: 880px;

    @include flex-container(column, flex-start);
    gap: 16px;
  }

  &__button {
    align-self: center;
  }
}
</style>
